import {
  DeliveryOrderFoodModel,
  DeliveryOrderFoodQueryModel,
  DeliveryOrderFoodSumModel,
} from '@/model/deliveryOrderFood';
import { ResultModel } from '@/model/viewModel';
import { post } from '@/utils/api';

export const getDeliveryOrderFood = (data: DeliveryOrderFoodQueryModel) =>
  post<ResultModel<DeliveryOrderFoodModel>>('/report/selectDeliveryOrderFood', data);

export const getDeliveryOrderFoodSum = (data: DeliveryOrderFoodQueryModel) =>
  post<DeliveryOrderFoodSumModel>('/report/selectDeliveryOrderFoodSum', data);
